import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/shared/models/api-response.model';
import { Company } from '../models/Company';
import { Guid } from 'guid-typescript';
import { RequestSearchResultDto, RequestsSearchDto } from 'src/app/modules/workFlow/models/request-models';
import { SearchDto1 } from 'src/app/shared/models/paging/request/search-dto';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  constructor(private http: HttpClient) { }
  getCompanyRequests(requestsSearchDto: RequestsSearchDto): Observable<ApiResponse<SearchDto1<RequestSearchResultDto>>> {
    return this.http.post<ApiResponse<SearchDto1<RequestSearchResultDto>>>('/api/Company/FilterCompanyRequests', requestsSearchDto);
  }


  exportRequests(requestsSearchDto: RequestsSearchDto): void {
    this.http.post('/api/Company/FilterCompanyRequests', requestsSearchDto, { responseType: 'blob' }).subscribe(response => {
      const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      // Create download link
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Requests.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    });
  }

  CleanEmptyAttributes(obj: any) {
    for (var propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
        delete obj[propName];
      }
    }
    return obj
  }

  getCompanyProfileRequestById(id: any): Observable<any> {
    return this.http.get<any>('/api/Company/GetCompanyRequestById/' + id);
  }
  GetHomePageStatics(): Observable<any> {
    return this.http.get<any>('/api/Company/GetHomePageStatics');
  }

  getCompanyProfileRequestByCRN(crn: any): Observable<any> {
    return this.http.get<any>('/api/Company/GetCompanyRequestByCRN/' + crn);
  }

  addCompanyProfileRequest(post: any): Observable<any> {
    return this.http.post<any>('/api/Company/AddCompanyProfileRequest', post);
  }
  addEmployeeToCompany(post: any): Observable<any> {
    return this.http.post<any>('/api/Company/AddEmployeeToCompany', post);
  }
  EditCompanyProfileRequest(post: any): Observable<any> {
    return this.http.post<any>('/api/Company/EditCompanyProfileRequest', post);
  }
  EditExecutiveManagementInformation(post: any): Observable<any> {
    return this.http.post<any>('/api/Company/EditExecutiveManagementInformation', post);
  }
  ReviewCompanyProfileRequest(post: any): Observable<any> {
    return this.http.post<any>('/api/Company/ReviewCompanyProfileRequest', post);
  }

  GetSDIFCompanies(): Observable<any> {
    return this.http.get<any>('/api/Company/GetSDIFCompanies');
  }
  GetCompanyStatuses(): Observable<any> {
    return this.http.get<any>('/api/Company/GetCompanyStatusList');
  }


  GetApprovedCompanies(): Observable<any> {
    return this.http.get<any>('/api/Company/GetApprovedCompanies');
  }

  CheckIfCompanyAddedBefore(CRNumber: any): Observable<any> {
    return this.http.get<any>('/api/Company/CheckIfCompanyAddedBefore?CRNumber=' + CRNumber);
  }

}
